<template>
    <div>
        <app-table :id="tableId" :options="options" @action="getListAction" />

        <modify-scope-process-modal
          v-if="isAddEditModalActive"
          :preloader="deleteLoader"
          :table-id="tableId"
          :acc-app-id="accAppId"
          :activity="activity"
          @close-modal="closeAddEditModal"
        />
    </div>
    
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import * as actions from "../../apiUrl";
import { TableHelpers } from "./TableHelpers";
export default {
  extends: CoreLibrary,
  mixins: [TableHelpers],
  data() {
    return {
      tableId: "modify-scope-process-tab",
      isAddEditModalActive: false,
      deleteLoader: false,
      rowData: {},
      accAppId:"",
      activity:"",
      options: {
        name: "modify-scope-process-tab",
        url: `/accreditationtechnical/modifyScopes/indexProcess`,
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("Alcance"),
            icon: "eye",
            type: "none",
          },
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
          },
        ],
        showFilter: true,
        showSearch: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },
  created() {
    this.$hub.$on("reload-table", this.reloadTable);
    this.options.columns = [...this.tableColumns, this.actionObj];
    this.data();
  },
  methods: {
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == this.$t("Alcance")) {
        this.accAppId = this.rowData.id;
        this.activity = this.rowData.accreditation_activity.code;
        this.openAddEditModal();
      } else if (actionObj.title == this.$t("edit")) {
          if (["608", "609", "610", "611", "612", "613"].includes(this.rowData.status.code)) {
            this.$toastr.e("Los alcances ya no se pueden editar por que se encuentran en una etapa de Toma de decisión");
            return ;
          } else {
            window.location = `/accreditationtechnical/modifyScopes/viewProcess/${this.rowData.id}`;
          }
      } 
    },
    data() {},
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    
    closeAddEditModal() {
      $("#modal-add-edit-modify-inf").modal("hide");
      this.isAddEditModalActive = false;
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    reloadTable: function () {
      this.$hub.$emit("reload-" + this.tableId);
    },
  },

}
</script>

<style>

</style>